import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { BusinessServiceDetailPanel } from '../../panels';
import { BusinessServiceFilter, TimeRangeFilter, useBusinessService } from '../../filters';

export const pageId = 'business-service-detail';

export default function BusinessServiceDetailPage() {
    const businessService = useBusinessService();
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={businessService?.name}
                titleActions={
                    businessService &&
                    !businessService.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/business-services/${businessService?.uuid}`}
                                title={i18n._(t`Edit business service configuration`)}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <BusinessServiceDetailPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
